<template>
  <div>
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:orgId>
        <el-select multiple v-model="filters.orgId" filterable placeholder="请选择">
          <el-option
            v-for="item in organizations"
            :label="item.customName"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:warehouseId>
        <el-select multiple v-model="filters.warehouseId" placeholder="请选择">
          <el-option
            v-for="item in warehouses"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>

      <template slot-scope="scope" slot="twDeliveryNo">
        <el-link
          :underline="false"
          type="primary"
          @click.native="dialogDetail(scope.row)"
          >{{ scope.row.twDeliveryNo }}
        </el-link>
        <br/>
        <el-link type="info"> {{ scope.row.relationNumber }}</el-link>
      </template>
    </TwTable>

    <el-dialog
      title="收货详情"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      :visible.sync="visibledialogDetail"
      v-model="visibledialogDetail"
      width="80%"
    >
      <el-form :model="DetailForm" label-width="80px" ref="editForm">
        <!-- 收货详情 -->

        <el-card shadow="hover" style="margin-top: 10px; width: 100%">
          <div slot="header" class="clearfix">
            <span>送货详情</span>
          </div>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="送货单号:"
                prop="twDeliveryNo"
                class="labelcall"
                label-width="120px"
              >
                {{ this.DetailForm.twDeliveryNo }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                prop="relationNumber"
                label="参考单号："
                class="labelcall"
                label-width="120px"
                style="width: 100%"
              >
                {{ this.DetailForm.relationNumber }}
              </el-form-item>
            </el-col>
          </el-row>
 <!-- <el-row>
            <el-col :span="12">
              <el-form-item
                label="签收单号:"
                prop="signForNumber"
                class="labelcall"
                label-width="120px"
              >
                {{ this.DetailForm.signForNumber }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                prop="putOnNo"
                label="上架单号："
                class="labelcall"
                label-width="120px"
                style="width: 100%"
              >
                {{ this.DetailForm.putOnNo }}
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="仓库："
                prop="warehouseName"
                class="labelcall"
                label-width="120px"
              >
                {{ this.DetailForm.warehouseName }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                prop="customName"
                label="客户："
                class="labelcall"
                label-width="120px"
                style="width: 100%"
              >
                {{ this.DetailForm.customName }}
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item
                label="追踪号："
                prop="trackNumber"
                class="labelcall"
                label-width="120px"
              >
                {{ this.DetailForm.trackNumber }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                prop="estimatedDateDesc"
                label="预计到仓时间："
                class="labelcall"
                label-width="120px"
                style="width: 100%"
              >
                {{ this.DetailForm.estimatedDateDesc }}
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item
                label="创建时间："
                prop="productUnit"
                class="labelcall"
                label-width="120px"
              >
                {{ this.DetailForm.createTimeDesc }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                prop="madeOrigin"
                label="实际到仓时间："
                class="labelcall"
                label-width="120px"
                style="width: 100%"
              >
                {{ this.DetailForm.actualArrivalDateDesc }}
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item
                prop="madeOrigin"
                label="总箱数："
                class="labelcall"
                label-width="120px"
                style="width: 100%"
              >
                {{ this.DetailForm.totalBoxCount }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="完成上架时间："
                prop="productUnit"
                class="labelcall"
                label-width="120px"
              >
                {{ this.DetailForm.overPutStockTimeDesc }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                prop="madeOrigin"
                label="总体积(m³)："
                class="labelcall"
                label-width="120px"
                style="width: 100%"
              >
                {{ this.DetailForm.totalVolumeDesc }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="总重量(kg)："
                prop="productUnit"
                class="labelcall"
                label-width="120px"
              >
                {{ this.DetailForm.totalGrossWeight }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                prop="madeOrigin"
                label="上架状态:"
                class="labelcall"
                label-width="120px"
                style="width: 100%"
              >
                {{ this.DetailForm.putOnStatusDesc }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- <el-form-item
                label="收货状态"
                prop="productUnit"
                class="labelcall"
                label-width="120px"
              >
                {{ this.DetailForm.signForStatusDesc }}
              </el-form-item> -->
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                prop="madeOrigin"
                label="说明:"
                class="labelcall"
                label-width="120px"
                style="width: 100%"
              >
                {{ this.DetailForm.remark }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <el-card shadow="hover" style="margin-top: 10px; width: 100%">
          <div slot="header" class="clearfix">
            <span>收货详情</span>
          </div>

          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="装箱信息" name="first">

              <div style="text-align:right">
                 <el-link type="info">预期数量:</el-link> {{this.receiveBoxData.expectBoxNum}} 
                 <el-link type="primary">目的仓收货数:</el-link>{{this.receiveBoxData.receiveBoxNum}} 
                <el-link type="success">上架数量:</el-link> {{this.receiveBoxData.putOnBoxNum}} 
              </div>
              <el-table
                :data="boxtabledata"
                highlight-current-row
                border
                style="width: 100%"
              >
               
                <el-table-column prop="boxMark" width="180" label="箱号">
                </el-table-column>
                <el-table-column prop="putStockBoxSatusDesc" width="120" label="上架状态">
                </el-table-column>
                <el-table-column
                  prop="skuCode"
                  width="300"
                  label="产品代码*送货数量*收货数量"
                >
                 <template slot-scope="scope" >
                     <p v-for="( item,index ) in scope.row.skuList" :key="index">
                     {{item.skuCode}}*{{item.deliveryQty}}*{{item.receiveQty}}    
                     </p>
                               
                 </template>
                </el-table-column>
                <el-table-column prop="BoxLength" width="300" label="尺寸(长*宽*高)">
                      <template slot-scope="scope">
                     {{scope.row.boxLength}}*{{scope.row.boxWidth}}*{{scope.row.boxHeight}}              
                 </template>
                </el-table-column>
                <el-table-column prop="boxWeight"  label="重量">
                </el-table-column>
              </el-table>
            </el-tab-pane>


            <el-tab-pane label="签收详情" name="second"> 
                 <el-table
                :data="signFortabledata"
                highlight-current-row
                border
                style="width: 100%"
              >
              
                <el-table-column prop="skuCode" width="200" label="产品代码">
                </el-table-column>
                <el-table-column prop="deliveryQty" width="160" label="预期数量">
                </el-table-column>
              
               
                <el-table-column prop="receiveQty" width="200" label="目的仓收货数">
                </el-table-column>
                <el-table-column prop="actualPutOnQty" label="上架数量">
                </el-table-column>
              </el-table>

            </el-tab-pane>
            <el-tab-pane label="收货日志" name="third">

                <el-table
                :data="receivetableData"
                highlight-current-row
                border
                style="width: 100%"
              >
               
                <el-table-column prop="createBy" width="160" label="操作人">
                </el-table-column>
                <el-table-column prop="ip" width="160" label="IP地址">
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  width="160"
                  label="操作时间"
                  :formatter="Dateformatter"
                >
                </el-table-column>
                <el-table-column prop="description"  label="操作内容">
                </el-table-column>
              
              </el-table>
               </el-tab-pane>
          
          </el-tabs>
        </el-card>

        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="centerDialogVisible = false"
            >确 定</el-button
          >
        </span>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import util from "../../../util/date";
import {
  GetPCReceiveManageList,
  PCReceiveManageExport,GetTWDeliveryBoxInfoList,GetReceiveBoxInfo,GetSkuSignInfoList,Commonlog,PCReceiveManageExportDetail
} from "@/api/receive/receiveList.js";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import Toolbar from "../../components/Toolbar";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import OperateDialog from "../../components/TwTable/components/operateDialog";
import LogDialog from "../../components/TwTable/components/logDialog";
import { getCustomerList } from "@/api/ProductSku.js";
import axios from "axios";
import { thereAre } from "util/util";
import {
  getInventoryDetailAsync,
  getBatchesInventoryAsync,
} from "../../api/api";
export default {
  components: { Toolbar, TwTable, OperateDialog, LogDialog },
  mixins: [TwTable_mixins],
  data() {
    return {
      tableConfig: {
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: false, // 显示操作栏
        operate: {
          width: "250",
          align: "center",
        },
        column: [
          // 表格列配置
          {
            prop: "twDeliveryNo",
            label: "送货单号",
            align: "center",
            sortable: true,
            minWidth: "160",
            slot: true,
            // formatter: function (val, row) {
            //   return row.twDeliveryNo + "<br/>" + row.relationNumber;
            // },
          },

          {
            prop: "customName",
            label: "客户",
            align: "center",
            sortable: true,
          },
          {
            prop: "warehouseName",
            label: "仓库",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "trackNumber",
            label: "追踪号",
            align: "center",
            sortable: true,
            minWidth: "160",
          },
          {
            prop: "shelfMethodDesc",
            label: "收货方式",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
          {
            prop: "twDeliveryInfoStatusDesc",
            label: "状态",
            align: "center",
            minWidth: "120",
            sortable: true,
          },
          {
            prop: "totalSKUCount",
            label: "货物明细",
            align: "left",
            minWidth: "180",
            // sortable: true,
            formatter: function (val, row) {
              var html =
                "总箱数：" +
                row.totalBoxCount +
                "<br/>" +
                "总Pcs数：" +
                row.totalPcsCount +
                "<br/>" +
                "总体积(m³)：" +
                row.totalVolumeDesc +
                "<br/>" +
                "总重量：" +
                row.totalGrossWeight;

              return html;
            },
          },

         

          {
            prop: "putOnStatusDesc",
            label: "上架状态",
            align: "center",
            sortable: true,
            minWidth: "160",
          },
          {
            prop: "CreateTime",
            label: "日期",
            align: "left",
            // sortable: true,
            minWidth: "240",
            formatter: function (val, row) {
              var html =
                "创建时间：" +
                row.createTimeDesc +
                "<br/>" +
                "预计到仓：" +
                row.estimatedDateDesc +
                "<br/>" +
                "实际到仓：" +
                row.actualArrivalDateDesc +
                "<br/>" +
                "完成收货：" +
                row.overSignForTimeDesc +
                "<br/>" +
                "完成上架：" +
                row.overPutStockTimeDesc +
                "<br/>";
              return html;
            },
          },
        ],
      },
      visibledialogDetail: false,
      InOutDetailTableData: [],
      batchesInventoryTableData: [],
      logListLoading: false,
      logListLoadingInOut: false,
      showLogInOut: false,
      showDialogInout: false,
      activeName: 'first',
      batchesInventoryListLoading: false,
      receiveBoxData:{},
      boxtabledata:[],
      signFortabledata:[],
      receivetableData:[],
      putOntableData:[],
      DetailForm: {},
      tabpara:{},
      
      searchData: {
        //搜索列配置

        search: [
          {
            type: "input",
            key: "TWDeliveryNo",
            label: "送货单号",
            placeholder: "送货单号",
            clearable: true,
          },

          {
            type: "input",
            key: "RelationNumber",
            label: "参考单号",
            placeholder: "采购单号",
            clearable: true,
          },
          {
            type: "select",
            key: "orgId",
            prop: "orgId",
            label: "客户",
            multiple: true,
            clearable: true,
            slot: true,
            filterable:true,
            placeholder: "请选择客户",
            option: this.organizations,
          },
          {
            type: "select",
            key: "warehouseId",
            prop: "warehouseId",
            label: "仓库",
            multiple: true,
            slot: true,
            placeholder: "请选择客户",
            option: this.warehouses,
          },

          {
            type: "input",
            key: "TrackNumber",
            label: "追踪号",
            placeholder: "追踪号",
            clearable: true,
          },

          {
            type: "select",
            key: "Status",
            prop: "Status",
            label: "状态",
            multiple: true,

            placeholder: "送货状态",
            options: [
              {
                label: "草稿",
                value: "10",
              },
              {
                label: "在途",
                value: "20",
              },
              {
                label: "部分收货",
                value: "30",
              },
              {
                label: "完全收货",
                value: "40",
              },
              {
                label: "完结",
                value: "50",
              },
            ],
          },
        ],
        ///高级搜索配置
        moreSearch: [],
      },
      buttonList: [],

      //-------------
      filters: {},
      organizations: [],
      warehouses: [],
      logPageConfiginOut: {
        // 日志分页配置
        total: 0,
        pageIndex: 0,
        pageSize: 20,
        pageSizes: [10, 20, 50, 100],
      },
    };
  },
  methods: {
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
         this.newfilters =JSON.parse(JSON.stringify(this.filters)) 
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },

    //查询列表
    initTable() {
      const {
        orgId,
        warehouseId,
        TWDeliveryNo,
        RelationNumber,
        TrackNumber,
        Status,
      } = this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        TWDeliveryNo: TWDeliveryNo,
        RelationNumber: RelationNumber,
        WarehouseIDs: thereAre(warehouseId),
        TrackNumber: TrackNumber,
        OrgIds: thereAre(orgId),
        Statuss: thereAre(Status),
      };

      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      GetPCReceiveManageList(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);

        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    Dateformatter(row,column){
      return util.formatDate.format(new Date(row.createTime), "yyyy-MM-dd hh:mm:ss");;


    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;

      let checkIds = "";
      row.forEach((item) => {
        checkIds += item.twDeliveryInfoID + ",";
      });
      if (checkIds != null || checkIds != "") {
        checkIds = checkIds.substring(0, checkIds.lastIndexOf(","));
      }

      const {
        orgId,
        warehouseId,
        TWDeliveryNo,
        RelationNumber,
        TrackNumber,
        Status,
      } = this.filters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        TWDeliveryNo: TWDeliveryNo,
        RelationNumber: RelationNumber,
        WarehouseIDs: thereAre(warehouseId),
        TrackNumber: TrackNumber,
        OrgIds: thereAre(orgId),
        Statuss: thereAre(Status),
        CheckIds: checkIds,
      };

      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: PCReceiveManageExport,
        method: "post",
        data: para,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
          loading.close();
        });
    },
     handleExportDetail() {
      let row = this.selectRows.rows;

      let checkIds = "";
      row.forEach((item) => {
        checkIds += item.twDeliveryInfoID + ",";
      });
      if (checkIds != null || checkIds != "") {
        checkIds = checkIds.substring(0, checkIds.lastIndexOf(","));
      }

      const {
        orgId,
        warehouseId,
        TWDeliveryNo,
        RelationNumber,
        TrackNumber,
        Status,
      } = this.filters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        TWDeliveryNo: TWDeliveryNo,
        RelationNumber: RelationNumber,
        WarehouseIDs: thereAre(warehouseId),
        TrackNumber: TrackNumber,
        OrgIds: thereAre(orgId),
        Statuss: thereAre(Status),
        CheckIds: checkIds,
      };

      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: PCReceiveManageExportDetail,
        method: "post",
        data: para,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
          loading.close();
        });
    },
    handleClick(tab, event) {

        var row= this.tabpara;
       if(this.activeName=='first'){
         
       var para={TWDeliveryInfoID:row.twDeliveryInfoID};
       GetTWDeliveryBoxInfoList(para).then((res) => {
        const { pageData } = res.data.response;
        this.boxtabledata = pageData;
       
      });


        var boxpara={TWDeliveryInfoID:row.twDeliveryInfoID,TrackNumber:row.trackNumber};
        GetReceiveBoxInfo(boxpara).then((res) => {
       
        this.receiveBoxData = res.data.response

        
      
      });


      
       }
       else if(this.activeName=='second'){
          var skupara={TWDeliveryInfoID:row.twDeliveryInfoID};
       GetSkuSignInfoList(skupara).then((res) => {
        const { pageData } = res.data.response;
       this.signFortabledata = pageData;
      
      });
       }
       else if(this.activeName=='third'){
           var signpara={businessType:11,businessCode:row.twDeliveryNo,page:1,pageSize:10000};
       Commonlog(signpara).then((res) => {
        const { pageData } = res.data.response;
       this.receivetableData = pageData;
      
      });
       }
        
      },
    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },

    dialogDetail(row) {
      this.DetailForm = Object.assign({}, row);

      this.tabpara=row;
     
      //this.DetailForm = rows;

      this.visibledialogDetail = true;

      var para={TWDeliveryInfoID:row.twDeliveryInfoID};
       GetTWDeliveryBoxInfoList(para).then((res) => {
        const { pageData } = res.data.response;
        this.boxtabledata = pageData;
       
      });


       var boxpara={TWDeliveryInfoID:row.twDeliveryInfoID,TrackNumber:row.trackNumber};
       GetReceiveBoxInfo(boxpara).then((res) => {
       
        this.receiveBoxData = res.data.response

        
      
      });

    //    var skupara={TrackNumber:row.trackNumber};
    //    GetSkuSignInfoList(skupara).then((res) => {
    //     const { pageData } = res.data.response;
    //    this.signFortabledata = pageData;
      
    //   });
      

    //  var signpara={businessType:11,businessCode:row.putOnNo};
    //    Commonlog(signpara).then((res) => {
    //     const { pageData } = res.data.response;
    //    this.receivetableData = pageData;
      
    //   });
      
      
     

    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);

    let user = JSON.parse(window.localStorage.user);
    this.warehouses = user.warehouseList;
    let para = {
      IsAll: false,
    };
    getCustomerList(para).then((res) => {
      this.organizations = res.data.response;
    });

   
  },
};
</script>

